import { render, staticRenderFns } from "./clipper-upload.vue?vue&type=template&id=3355369a&"
import script from "./clipper-upload.vue?vue&type=script&lang=js&"
export * from "./clipper-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports